
export default function Testimonial() {
  return (
    <section className="py-32 bg-slate-50 relative overflow-hidden">
      {/* Decorative Element */}
      <div className="absolute top-20 left-20 w-32 h-32 opacity-20">
        <svg viewBox="0 0 100 100" className="w-full h-full text-slate-900">
          <path d="M 10 50 Q 30 10, 50 50 T 90 50" stroke="currentColor" fill="none" strokeWidth="3" />
          <circle cx="50" cy="50" r="30" stroke="currentColor" fill="none" strokeWidth="2" />
        </svg>
      </div>

      <div className="max-w-6xl mx-auto px-8 relative">
        <div className="bg-slate-900 rounded-3xl overflow-hidden shadow-2xl flex items-stretch">
          {/* Left Image */}
          <div className="relative w-80 flex-shrink-0">
            <div className="w-full h-full overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20satisfied%20Japanese%20female%20customer%20in%20her%2030s%20smiling%20warmly%20at%20camera%2C%20business%20casual%20attire%2C%20neutral%20gray%20studio%20background%2C%20natural%20lighting%2C%20confident%20and%20happy%20expression%2C%20real%20estate%20client%20testimonial%20photo&width=600&height=800&seq=test-001&orientation=portrait"
                alt="お客様の声"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="flex-1 py-16 px-16 flex flex-col justify-center">
            {/* Quote Mark */}
            <div className="text-amber-200 text-6xl font-serif mb-6 leading-none">"</div>

            {/* Review Text */}
            <p className="text-white text-2xl leading-relaxed mb-8">
              担当者の方が親身になって相談に乗ってくださり、理想の物件に出会えました。契約後のサポートも手厚く、安心して新生活をスタートできました。
            </p>

            {/* Signature */}
            <div className="mb-10">
              <p className="text-white text-base font-medium mb-1">田中 美咲 様</p>
              <p className="text-slate-400 text-sm">港区 マンション購入</p>
            </div>

            {/* Button */}
            <div>
              <button
                className="inline-flex items-center gap-3 px-8 py-4 bg-white text-slate-900 rounded-full hover:bg-slate-100 transition-colors font-medium whitespace-nowrap cursor-pointer"
              >
                お客様の声一覧
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
